export default __webpack_public_path__ + "static/media/help-center.35f3b8d6.svg";